import { get, post, put, remove } from './mainApi';

const employeeServiceBaseURL =
  process.env.REACT_APP_PROJECT_MANAGEMENT_ENDPOINT;

export const getAllProjects = async () => {
  var response = get(`${employeeServiceBaseURL}project-group`);
  return response;
};

export const getHealthSummary = async (name) => {
  var response = get(`${employeeServiceBaseURL}filter-name?name=${name}`);
  return response;
};

export const searchProjects = async (groupName: string) => {
  var response = get(
    `${employeeServiceBaseURL}project-group/filter?name=${groupName}`
  );
  return response;
};

export const getLatestProject = async () => {
  var response = get(`${employeeServiceBaseURL}project-group/latest`);
  return response;
};

export const getExternalLeads = async () => {
  var response = get(`${employeeServiceBaseURL}external-lead`);
  return response;
};

export const AddProject = async (project) => {
  var response = post(`${employeeServiceBaseURL}project-group`, project);
  return response;
};

export const DeleteProject = async (projectId) => {
  var response = remove(`${employeeServiceBaseURL}project-group/${projectId}`);
  return response;
};

export const UpdateProject = async (project) => {
  var response = put(`${employeeServiceBaseURL}project-group`, project);
  return response;
};

// segments
export const getLatestSegmentCode = async () => {
  var response = get(`${employeeServiceBaseURL}segment/latest`);
  return response;
};

export const getSegments = async () => {
  var response = get(`${employeeServiceBaseURL}segments`);
  return response;
};

export const createSegment = async (segment) => {
  var response = post(`${employeeServiceBaseURL}segment`, segment);
  return response;
};

export const updateSegment = async (segment) => {
  var response = put(`${employeeServiceBaseURL}segment`, segment);
  return response;
};

export const getCountries = async () => {
  var response = get(`${employeeServiceBaseURL}countries`);
  return response;
};

export const getLatestCustomerCode = async () => {
  var response = get(`${employeeServiceBaseURL}segment/customer/latest`);
  return response;
};

export const createCustomer = async (customer) => {
  var response = post(`${employeeServiceBaseURL}segment/customer`, customer);
  return response;
};

export const updateCustomer = async (customer) => {
  var response = put(`${employeeServiceBaseURL}segment/customer`, customer);
  return response;
};

export const createStakeHolder = async (stakeholder) => {
  var response = post(
    `${employeeServiceBaseURL}segment/customer/stakeholder`,
    stakeholder
  );
  return response;
};

export const updateStakeHolder = async (stakeholder) => {
  var response = put(
    `${employeeServiceBaseURL}segment/customer/stakeholder`,
    stakeholder
  );
  return response;
};

export const deleteSegment = async (id) => {
  var response = remove(`${employeeServiceBaseURL}segments?Id=${id}`);
  return response;
};

export const deleteCustomer = async (id) => {
  var response = remove(`${employeeServiceBaseURL}segments/customer?Id=${id}`);
  return response;
};

export const deleteStakeholder = async (id) => {
  var response = remove(
    `${employeeServiceBaseURL}segments/customer/stakeholder?Id=${id}`
  );
  return response;
};

export const getAllCustomers = async () => {
  var response = get(`${employeeServiceBaseURL}segment/customer/all`);
  return response;
};

export const searchCustomers = async (name) => {
  var response = get(`${employeeServiceBaseURL}segments/customer?name=${name}`);
  return response;
};

export const getAllStakeholders = async () => {
  var response = get(
    `${employeeServiceBaseURL}segment/customer/stakeholder/all`
  );
  return response;
};

export const getStakeholdersById = async (id) => {
  var response = get(`${employeeServiceBaseURL}customer/stakeholder?Id=${id}`);
  return response;
};

export const getSegmentByCustomer = async (id) => {
  var response = get(`${employeeServiceBaseURL}segment/by-customer?id=${id}`);
  return response;
};

export const searchStakeholders = async (name) => {
  var response = get(
    `${employeeServiceBaseURL}segments/customer/stakeholder?name=${name}`
  );
  return response;
};

export const getTeams = async (code) => {
  var response = get(
    `${employeeServiceBaseURL}project-role?projectCode=${code}`
  );
  return response;
};

export const createTeam = async (data) => {
  var response = post(`${employeeServiceBaseURL}project-role`, data);
  return response;
};

export const createTeamResource = async (data) => {
  var response = post(`${employeeServiceBaseURL}resource-allocation`, data);
  return response;
};

export const createMultipleTeamResource = async (resources: any) => {
  const promises: any = [];
  resources.forEach((resource) => {
    promises.push(
      post(`${employeeServiceBaseURL}resource-allocation`, resource)
    );
  });

  await Promise.all(promises);
};

export const searchTeams = async (data) => {
  var response = post(`${employeeServiceBaseURL}project-role/search`, data);

  return response;
};

export const filterTeams = async (data) => {
  var response = post(`${employeeServiceBaseURL}project-role/filter`, data);
  return response;
};

export const updateTeamResources = async (data) => {
  var response = put(`${employeeServiceBaseURL}project-role`, data);
  return response;
};

export const deleteTeamRole = async (id) => {
  var response = remove(`${employeeServiceBaseURL}project-role?roleCode=${id}`);
  return response;
};

export const getProjectTotalAllocation = async () => {
  var response = get(`${employeeServiceBaseURL}resources`);
  return response;
};

export const searchResource = async (name) => {
  var response = get(`${employeeServiceBaseURL}resource-search?name=${name}`);
  return response;
};

export const filterResource = async (data) => {
  var response = post(`${employeeServiceBaseURL}resource-search`, data);
  return response;
};

export const getSingleResourceAllocation = async (id) => {
  var response = get(
    `${employeeServiceBaseURL}resource-by-id?employeeId=${id}`
  );
  return response;
};

export const resourceAllocationUpdate = async (resources: any) => {
  const promises: any = [];
  resources.forEach((resource) => {
    promises.push(
      put(`${employeeServiceBaseURL}resource-allocation-update`, resource)
    );
  });

  await Promise.all(promises);
};

export const resourceDeAllocationMultiple = async (ids: any) => {
  const promises: any = [];
  ids.forEach((id) => {
    promises.push(
      post(`${employeeServiceBaseURL}resource-deallocation`, {
        allocationId: id
      })
    );
  });

  await Promise.all(promises);
};

export const resourceDeAllocation = async (id) => {
  var response = post(`${employeeServiceBaseURL}resource-deallocation`, {
    allocationId: id
  });
  return response;
};

export const searchSegments = async (name) => {
  var response = get(`${employeeServiceBaseURL}segments-by-name?name=${name}`);
  return response;
};

export const getSingleProjectAllocationDetails = async (data) => {
  var response = post(`${employeeServiceBaseURL}resource-by-filters`, data);
  return response;
};

export const downloadProjectReport = async () => {
  const response = get(`${employeeServiceBaseURL}download`, 'blob');
  return response;
};

export const GetEmployeeProjectDetails = async (id) => {
  var response = get(`${employeeServiceBaseURL}my-projects?Id=${id}`);
  return response;
};

export const getProjectManagerDetailsByProject = async (project) => {
  var response = post(`${employeeServiceBaseURL}project-manager-by-project`, project);
  return response;
};

/** Projects the employee manages (Project Manager allocation) overlapping the date range. */
export const getProjectsManagedBy = async (employeeId: string, startDate: string, endDate: string) => {
  var response = post(`${employeeServiceBaseURL}projects-by-project-manager`, {
    employeeId,
    startDate,
    endDate
  });
  return response;
};